module.exports = __webpack_public_path__ + "static/media/message1.f4cfda34.png";